import React, { useState, useEffect, useRef } from 'react';
import './popup-button.scss';

import classNames from 'classnames';
import PropTypes from 'prop-types';

const PopupButton = ({
  buttonBody,
  popupBody,
  popupPosition = 'right',
  className,
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const [popupContentMarginTop, setPopupContentMarginTop] = useState(0);
  const popupRef = useRef(null);
  const buttonRef = useRef(null);

  const handleClickOutside = useRef((e) => {
    const targetEl = e.target;
    const popupEl = popupRef.current;

    if (popupEl && targetEl instanceof Node && !popupEl.contains(targetEl)) {
      setIsOpened(false);
    }
  }).current;

  const handleButtonClick = (e) => {
    e.stopPropagation();
    setIsOpened(prevState => !prevState);
  };

  useEffect(() => {
    if (isOpened) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    return () => document.removeEventListener('click', handleClickOutside);
  }, [handleClickOutside, isOpened]);

  useEffect(() => {
    const buttonHeight = buttonRef.current.offsetHeight;
    setPopupContentMarginTop(buttonHeight + 20);
  }, []);

  return (
    <div className={classNames('popup-button', { 'popup-button--closed': !isOpened }, className)}>
      <button
        className={classNames('popup-button__button', { 'popup-button__button--close': isOpened })}
        type="button"
        ref={buttonRef}
        onClick={handleButtonClick}
      >{buttonBody}
      </button>
      <div
        className={classNames('popup-button__popup',
          { 'popup-button__popup--left': popupPosition === 'left', 'popup-button__popup--opened': isOpened })}
        ref={popupRef}
      >
        <div className="popup-button__popup-content" style={{ marginTop: popupContentMarginTop }}>
          {popupBody}
        </div>
      </div>
    </div>
  );
};

PopupButton.propTypes = {
  buttonBody: PropTypes.node,
  popupBody: PropTypes.node,
  popupPosition: PropTypes.string,
  className: PropTypes.string,
};

PopupButton.defaultProps = {
  buttonBody: undefined,
  popupBody: undefined,
  popupPosition: 'right',
  className: undefined,
};

export default PopupButton;
